import { postAPI, getAPI, putAPI } from '../../api/api'
import { REACT_APP_JOB, REACT_APP_JOBFILTER } from '../../utils/common'

export async function updatePositionAPI(body: any){
  const Details = putAPI( REACT_APP_JOB + '/job-status', body)
  return Details
}

export async function updateLossCountAPI(body: any){
  const Details = postAPI(  REACT_APP_JOB + '/loss-count', body)
  return Details
}

export async function updateCrowdSourcingStatus(data: any){
  const Details = postAPI( REACT_APP_JOB  + `/job-crowd-sourcing-status`, data)
  return Details
}

export async function getCsrAppliedCandidates(jobId: string, recruiterId: any){
  const Details = getAPI( REACT_APP_JOB + `/csr-applied-resources/${jobId}`)
  return Details
}

export async function getProviderResources(jobId: string){
  const Details = getAPI( REACT_APP_JOBFILTER + `/provider-applied-resources/${jobId}`)
  return Details
}

export async function postCandidateToJob(body: any) {
  const Details = postAPI( REACT_APP_JOB + '/candidate-position', body)
  return Details
}

